import {
  getAdminStatistics,
  getCardStatistics,
} from '@/services/statisticService';
import { AdminStatistics, CardStatistics } from '@/types/statistic';
import { handleError } from '@/utils/handleError';
import { create } from 'zustand';

interface StatisticsState {
  adminStatistics: AdminStatistics | null;
  cardStatistics: CardStatistics | null;
  isLoading: boolean;

  fetchAdminStatistics: () => Promise<void>;
  fetchCardStatistics: (slug: string) => Promise<void>;
}

export const useStatisticsStore = create<StatisticsState>(set => ({
  adminStatistics: null,
  cardStatistics: null,
  isLoading: false,

  fetchAdminStatistics: async () => {
    try {
      set({ isLoading: true });
      const response = await getAdminStatistics();
      set({ adminStatistics: response.data, isLoading: false });
    } catch (error) {
      handleError(error);
    }
  },

  fetchCardStatistics: async (slug: string) => {
    try {
      set({ isLoading: true });
      const response = await getCardStatistics(slug);
      set({ cardStatistics: response.data, isLoading: false });
    } finally {
      set({ isLoading: false });
    }
  },
}));
